import React, { useState, useCallback } from 'react';
import { Box, Button, Flex, useToast, Textarea } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { sendMessage } from '../../redux/actions/conversationActions';
import ComposeNumbers from './ComposeNumber';

import { IoSend } from 'react-icons/io5';

const maxCharacters = 160;

const ThreadCompose = () => {
  const dispatch = useDispatch();
  const activeProspect = useSelector((s) => s?.conversation?.activeProspect);
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const [text, setText] = useState('');

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (selectedNumbers.length === 0) {
        toast({
          title: 'Select a number',
          status: 'error',
          duration: 1500,
          isClosable: true,
          position: 'bottom-left',
        });
        return;
      }

      if (!text.trim()) return;

      setLoading(true);

      const payload = {
        prospectId: activeProspect?._id || '',
        to: selectedNumbers,
        text,
      };

      dispatch(sendMessage(payload.prospectId, payload.to, payload.text));

      setText(''); // clear input after send
      setLoading(false);
    },
    [activeProspect, selectedNumbers, text, dispatch, toast], // all deps included
  );

  return (
    <Box width="100%" display="flex" justifyContent="space-between">
      <Box width="95%" mb={4} mt={4} pl={6}>
        <Box mb={1.5}>
          <ComposeNumbers
            prospect={activeProspect}
            onSelectionChange={setSelectedNumbers}
          />
        </Box>
        <Flex gap={2} alignItems="center">
          <Textarea
            name="content"
            placeholder="Type a message"
            borderRadius="md"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSubmit(e);
              }
            }}
            isDisabled={loading}
            resize="none"
            fontSize="14px"
            size="md"
            color="#545454"
            maxWidth="100%"
            _focus={{
              boxShadow: 'none',
              border: 'solid 1px #e3e3e3',
            }}
            minHeight="40px"
            padding="10px 12px"
            overflow="hidden"
            autoFocus
            rows={1}
            style={{ color: 'white' }}
            maxLength={maxCharacters}
          />
          <Button
            background="#854DFF"
            color="white"
            fontSize={14}
            fontWeight={500}
            ms={3}
            onClick={handleSubmit}
            isLoading={loading}
            loadingText="Sending..."
            _hover={{ color: 'white', background: '#854DFF' }}
          >
            <IoSend />
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default ThreadCompose;
